import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-4">
      <pre className="text-destructive">
        {`
  404 - PAGE NOT FOUND
  ==================
  SYSTEM MALFUNCTION
        `}
      </pre>
      <button
        onClick={() => navigate('/')}
        className="px-4 py-2 bg-primary text-primary-foreground rounded"
      >
        Return to Base
      </button>
    </div>
  );
};

export default NotFoundPage;